<template>
  <section class="blogs">
    <form method="post" @submit.prevent="onSend">
      <b-field>
        <b-table
          :data="blogs"
          :loading="loading"
          :checked-rows.sync="checkedRows"
          :hoverable="true"
          :narrowed="true"
          :row-class="row => row.status === 0 && 'is-info'"
          :mobile-cards="false"
          checkable
        >
          <b-table-column
            field="status"
            :label="$t('attributes.activation_status')"
            width="95"
            v-slot="props"
          >
            <b-icon :icon="props.row.status ? 'check' : 'close'"></b-icon>
          </b-table-column>

          <b-table-column
            field="url"
            :label="$t('attributes.preview')"
            v-slot="props"
          >
            <a :href="props.row.url" target="_blank">
              {{ attributeType(props.row.attribute) }}
            </a>
          </b-table-column>

          <b-table-column
            field="topic"
            :label="$t('attributes.topic')"
            v-slot="props"
          >
            {{ props.row.topic }}
          </b-table-column>

          <b-table-column
            field="topic"
            :label="$t('attributes.author')"
            v-slot="props"
          >
            {{ props.row.member_name }}
          </b-table-column>

          <template #empty>
            <section class="section">
              <div
                v-if="!loading"
                class="content has-text-grey has-text-centered"
              >
                <p>
                  <b-icon icon="emoticon-sad" size="is-large" />
                </p>
                <p>{{ $t('attributes.empty') }}</p>
              </div>
            </section>
          </template>
        </b-table>
      </b-field>

      <b-field>
        <b-button
          disabled="disabled"
          :loading="sending"
          type="is-primary"
          native-type="submit"
          :style="{ width: '100%' }"
        >
          {{ $t('attributes.update_data') }}
        </b-button>
      </b-field>
    </form>
  </section>
</template>

<script>
import { TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'TravelGroupBlogsForm',

  props: {
    travelGroup: {
      required: true,
      type: Object
    },
    catalogList: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      loading: false,
      sending: false,

      blogs: [],
      checkedRows: []
    }
  },
  watch: {
    travelGroup(group) {
      this.loadBlogs(group.code)
    }
  },
  mounted() {
    this.loadBlogs(this.travelGroup.code)
  },
  methods: {
    async loadBlogs(code) {
      const api = `${TRAVEL_GROUPS_API}/${code}/catalogs/blogs`

      try {
        this.loading = true
        const res = await this.axios.get(api)
        this.blogs = res.data.data

        this.updateCheckedRows(this.travelGroup, this.blogs)
      } catch (e) {
        this.blogs = []

        notifyService.fetch_error('blog_share', e)
      } finally {
        this.loading = false
      }
    },
    updateCheckedRows(group, blogs) {
      if (!blogs || !group || !group.blog_ids) {
        return { checkedRows: [] }
      }

      this.checkedRows = blogs.filter(blog => {
        return group.blog_ids.includes(blog.id)
      })
    },
    async onSend() {
      const api = `${TRAVEL_GROUPS_API}/${this.travelGroup.code}/blogs`
      const data = {
        blog_ids: this.checkedRows.map(c => c.id)
      }

      this.sending = true
      try {
        const res = await this.axios.put(api, data)

        this.$emit('updated', res.data.data)
        notifyService.success(this.$t('attributes.update_succeed'))
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    },
    attributeType(attribute) {
      let type = '外連'
      switch (attribute) {
        case 'A':
          type = '外連'
          break
        case 'B':
          type = '內連'
          break
      }

      return `${this.$t('attributes.preview')}(${type})`
    }
  }
}
</script>

<style lang="scss">
.blogs {
  tr.is-info {
    background-color: #f5f5f5;
    color: #363636;
  }
}
</style>
